module.exports = __webpack_public_path__ + "static/media/SaveAway401kUniversalK.2e6d2c2c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Assets/SaveAway401kUniversalK.pdf
// module id = 317
// module chunks = 0